<template>
	<div>
		<div class="dynamic-list" v-for="item in list">
			<div class="userList" @click="toDetail(item)">
				<div class="userList-l">
					<div class="userList-img">
						<el-image :src="item.headPic">
							<img slot="error" src="../assets/default_head.png"/>
						</el-image>
						<span class="userList-level" v-if="item.memberLevel">{{item.memberLevel}}</span>
					</div>
					<div class="userList-cnt">
						<div class="userList-cnt-t">
							<span class="userList-txt">{{item.nickName}}</span>
							<span class="status" v-if="item.completeFlag==1">有活动未完成</span>
						</div>
						<div class="userList-time">{{item.addTimeStr}}</div>
					</div>
				</div>
				<div class="userList-r">
					{{item.schoolName}}
				</div>
			</div>
			<div class="dynamic-list-r">
				<div class="dynamic-desc"  @click="toDetail(item)">{{item.title}}</div>
				<div class="dynamic_imgbox">
					<div class="dynamic-img" v-if="item.feedType==2&&index<3" v-for="(videoItem,index) in item.attachList">
						<video controls :src="videoItem.fileUrl" style="">
							您的浏览器不支持 video 标签。
						</video>
					</div>
					<div class="dynamic-img" v-if="item.feedType!=2&&index<3&&item.previewList.length>0" v-for="(imageItem,index) in item.previewList">
						<!-- <img :src="imageItem.fileUrl" /> -->
						<el-image
							:src="imageItem"
							:preview-src-list="item.previewList"
						>
						</el-image>
					</div>
				</div>
				<div class="dynamic_info" @click="toDetail(item)">
					<span>{{item.formatTime}}</span>
					<span v-if="item.vacationName"> | {{item.vacationName}}</span>
				</div>
				<div class="organizer" @click="toDetail(item)">
					<div class="organizer-l">{{item.startCompayName}}</div>
					<div class="organizer-r">
						<img v-for="imgItem in item.logoUrlList" :src="imgItem" />
					</div>
				</div>
				<div class="dynamic-tips" @click="toDetail(item)">
					<div class="tips-list">
						<span class="el-icon-view"></span>
						<span>{{item.feedPageView}}</span>
					</div>
					<div class="tips-list">
						<span class="el-icon-thumb"></span>
						<span>{{item.praiseNum}}</span>
					</div>
					<div class="tips-list">
						<span class="el-icon-chat-dot-square"></span>
						<span>{{item.commentNum}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'DynamicItem',
		props: {
			list: {
				type: Array,
				value: []
			}
		},
		methods: {
			toDetail(item){
				console.log(item)
				this.$router.push({
					path: '/dynamic/dynamicDetail/'+item.feedId
				})
			}
		}
	}
</script>

<style scoped lang="less">
	@import './dynamicItem.less';
</style>
